export enum TiposAtendimentosSolar {
  LIGACAO = 0, // Ligação
  INICIAL = 1, // Inicial
  RETORNO = 2, // Retorno
  RECEPCAO = 3, // Recepção
  NUCLEO = 4, // Apoio de Núcleo Especializado
  ANOTACAO = 5, // Anotação
  PROCESSO = 6, // Processo
  VISITA = 7, // Visita ao Preso
  INTERESSADO = 8, // Atendimento ao Interessado
  ENCAMINHAMENTO = 9, // Encaminhamento
  ATIVIDADE = 10, // tividade
  RECLAMACAO = 11, // Reclamacao pelo disk
  INFORMACAO = 12, // Informacao pelo disk
  OFICIO = 13, // Ofício encaminhado
  OFICIO_FINALIZADO = 14, // Ofício finalizado
  DESARQUIVAMENTO = 998, // Atendimento desarquivado
  ARQUIVAMENTO = 999, // Atendimento arquivado
  NUCLEO_PEDIDO = 1031, // Solicitação de Apoio de Núcleo Especializado
  NOTIFICACAO = 1092, // Notificação
}
